import React from "react";
import refrigeratedImage from "../../assets/images/Home/refrigerated-truck-service-chiller-freeze.webp";
import "../../styles/RefrigeratedTruckUAEWhy.css";

const RefrigeratedTruckAboutUs = () => {
  return (
    <section className="refrigerated-uae-section py-5">
      <div className="container-fluid container-lg">
        <div className="row align-items-center refrigerated-uae-row">

          {/* LEFT COLUMN - IMAGE */}
          <div className="col-md-6 text-center" data-aos="fade-right" data-aos-delay="300">
            <img
              src={refrigeratedImage}
              alt="Refrigerated Chiller and Freezer Trucks UAE"
              className="refrigerated-uae-img img-fluid rounded"
              loading="lazy"
            />
          </div>

          {/* RIGHT COLUMN - TEXT */}
         <div className="col-md-6" data-aos="fade-left" data-aos-delay="300">
  <h2 className="refrigerated-uae-title">
    Refrigerated Truck Specifications & Advantages Over Other Cold Transport
  </h2>

  <p className="refrigerated-uae-desc">
    Refrigerated trucks are built for <strong>high-volume cold transport</strong>, offering greater payload 
    capacity compared to standard chiller vans while maintaining excellent fuel efficiency. This makes them 
    a cost-effective solution for businesses handling <strong>bulk food distribution, dairy supply, catering logistics, 
    and pharmaceutical deliveries</strong> across the UAE.
  </p>

  <p className="refrigerated-uae-desc">
    Designed to support both <strong>chilled and moderately frozen cargo</strong>, these trucks provide 
    flexible temperature ranges suitable for a wide variety of goods. With <strong>insulated bodies, advanced 
    airflow systems, and organized shelving</strong>, they ensure even cooling, reduce product movement, 
    and minimize handling risks during transit.
  </p>

  <p className="refrigerated-uae-desc">
    Compared to smaller cold transport vehicles, <strong>refrigerated trucks deliver more stability, 
    better load management, and consistent cooling performance</strong> over long distances. This helps 
    businesses maintain <strong>product quality, hygiene standards, and on-time delivery</strong> while 
    reducing spoilage and operational losses.
  </p>

  <p className="refrigerated-uae-desc">
    Whether operating in <strong>Dubai, Abu Dhabi, or Sharjah</strong>, refrigerated trucks remain a 
    reliable choice for companies seeking <strong>scalable, compliant, and efficient cold chain logistics solutions</strong>.
  </p>
</div>

        </div>
      </div>
    </section>
  );
};

export default RefrigeratedTruckAboutUs;